import { render, staticRenderFns } from "./user-create.vue?vue&type=template&id=63a64b48&"
import script from "./user-create.ts?vue&type=script&lang=js&"
export * from "./user-create.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports